import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Rule } from '../../../interfaces/Rule';
import { Ruleset } from '../../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPropertyLeased,
  IsPropertyOwnerAnotherBusiness,
} from '../../rules';
import IsPropertyLandlord from '../../rules/IsPropertyLandlord';
import { BaseRuleset } from '../BaseRuleset';

class PropertyOwnerBusinessNameRuleset extends BaseRuleset implements Ruleset {
  protected rules: Rule[] = [IsPropertyLeased, IsPropertyOwnerAnotherBusiness];

  private index: number;

  public setIndex(index: number): PropertyOwnerBusinessNameRuleset {
    this.index = index;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isLeased = IsPropertyLeased.evaluate(data);
    const isAnotherBusiness = IsPropertyOwnerAnotherBusiness.evaluate(data);
    const isLandlord = IsPropertyLandlord.setIndex(this.index).evaluate(data);

    return isLeased && isAnotherBusiness && isLandlord
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PropertyOwnerBusinessNameRuleset();
